import { ApiError, get, post } from "#/client";
import type { User } from "./auth-store";

export interface AuthConfig {
  invitation_required: boolean;
}

export async function fetchAuthConfig(): Promise<AuthConfig> {
  return get<AuthConfig>("/auth/config");
}

export async function enrollTotp(currentCode?: string): Promise<{ otpauth_uri: string; secret: string }> {
  return post("/auth/totp/enroll", currentCode ? { current_code: currentCode } : {});
}

export async function confirmTotp(code: string): Promise<User> {
  return post<User>("/auth/totp/confirm", { code });
}

export async function resetPassword(
  username: string,
  code: string,
  newPassword: string,
): Promise<void> {
  await post("/auth/reset-password", {
    username,
    code,
    new_password: newPassword,
  });
}

export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  await post("/auth/change-password", {
    old_password: oldPassword,
    new_password: newPassword,
  });
}

export function authErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (error.response.status === 403) return "Invalid invitation code";
    if (error.response.status === 401) return "Invalid credentials or code";
    if (error.response.status === 400) return "This account does not have an authenticator set up";
    return error.message || fallback;
  }
  return fallback;
}
